import { createLifeGrid } from '../core/cells';

export const highLifeReplicator = createLifeGrid({
  "2,0": true,
  "3,0": true,
  "4,0": true,
  "1,1": true,
  "4,1": true,
  "0,2": true,
  "4,2": true,
  "0,3": true,
  "3,3": true,
  "0,4": true,
  "1,4": true,
  "2,4": true,
});